import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Photos',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("circle", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-miterlimit": "10", cx: "12", cy: "13.5", r: "5" }
      }), h("path", {
        attrs: { d: "M12 10c-1.93 0-3.5 1.57-3.5 3.5S10.07 17 12 17s3.5-1.57 3.5-3.5S13.93 10 12 10zm0 5.69c-.24 0-.44-.2-.44-.44s.2-.44.44-.44c.72 0 1.31-.59 1.31-1.31 0-.24.2-.44.44-.44s.44.2.44.44c0 1.2-.98 2.19-2.19 2.19z" }
      }), h("path", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", d: "M8.5 3.5l-2 3h-4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h19c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2h-4l-2-3h-7z" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-miterlimit": "10", x1: "10", y1: "6", x2: "14", y2: "6" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-miterlimit": "10", x1: "20", y1: "10", x2: "20", y2: "10" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "3.5", y1: "10", x2: "3.5", y2: "18" }
      })]
    );
  }
};